import React from 'react';
import PlotForm from '../form';

const DetailsTab = (props) => {
  return <PlotForm {...props} />;
};

export default DetailsTab;
